import React, { useState } from 'react'
import '../../Styles/Home.css';
import axios from 'axios';
import toast from 'react-hot-toast';
import { SERVER_URL } from '../../../Config';
export default function Section5() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${SERVER_URL}/api/v2/contact`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.status === 200) {
        toast.success("Message sent successfully! 🎉");
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      if (error.response) {
        console.error("Server Response:", error.response.data);
        toast.error(`Error: ${error.response.data.message || "Failed to send message."}`);
      } else {
        toast.error("Network error. Please try again.");
      }
    }
  };



  return (
    <div className='bg-white py-20 mt-20'>
      <div className='w-[90%] mx-auto bg-center bg-cover bg-no-repeat flex flex-col lg:flex-row justify-between items-end px-10 py-5' style={{ backgroundImage: "url('/assets/img/bg5.svg')", borderRadius: "80px" }}>
        <div className='lg:w-[40%]'>
          <div className='bounce'>
            <img src='/assets/img/connect.svg'></img>
          </div>
          <div>
            <h1 className='custom-font '>Lets Get in <span className='text-[#656ed3]'>Touch!</span></h1>
            <p className='font-normal text-[#1a1a1a] text-sm '>Have a question or need assistance? Reach <br></br>out to us via email, </p>
            <p className='font-normal text-[#1a1a1a] text-sm'>phone, or the contact form below. We're <br></br>eager to assist you.</p>
            <p className='font-semibold text-[#2264DC]'>Nice hearing from you!</p>
          </div>
          {/*       
          <div className='flex justify-start px-10 text-3xl gap-3 items-center'>
            <i class="fa-brands fa-facebook" style={{ color: "#2264DC" }}></i>
            <i class="fa-brands fa-whatsapp" style={{ color: "#2264DC" }}></i>
            <i class="fa-brands fa-telegram" style={{ color: "#2264DC" }}></i>
          </div>*/}
        </div>
        <form className='lg:w-[40%] flex flex-col gap-3' onSubmit={handleSubmit}>
          <div>
            <p className='font-normal text-black'>Full Name:</p>
            <input type='text' name='name' className='rounded-full w-full text-black outline-none border-2 px-2 py-2 font-normal border-[#2264dc]' onChange={handleChange} value={formData.name} required></input>
          </div>
          <div>
            <p className='font-normal text-black'>Email:</p>
            <input type='text' name='email' className='rounded-full w-full text-black outline-none border-2 px-2 py-2 font-normal border-[#2264dc]' onChange={handleChange} value={formData.email} required></input>
          </div>
          <div>
            <p className='font-normal text-black'>Message:</p>
            <textarea type='text' name='message' className='rounded-xl w-full text-black outline-none border-2 px-2 py-2 font-normal border-[#2264dc]' onChange={handleChange} value={formData.message} required></textarea>
          </div>
          <div className='flex justify-end'>
            <button type='submit' className='text-white bg-[#2264DC]  px-5 py-2' style={{ borderRadius: "12px" }} >Submit</button>
          </div>
        </form>
      </div>
    </div>
  )
}
